import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { DefaultTable } from 'twyne-new.ui'

import { useGlobalStore } from '@Stores/global'
import { fallback } from './utils'


const propTypes = {
  data: PropTypes.object,
  siteId: PropTypes.number,
  answered: PropTypes.func
}

function CustomFieldsResult ({ data, siteId, answered }) {
  const { customFields: { getFields } } = useGlobalStore()
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (data && siteId)
      setFields()
  }, [])

  const setFields = async () => {
    const customFields = await getFields({ parse: true })
    const rows = []

    for (let [ key, value ] of Object.entries(data)) {
      if (internalUseCases(key))
        continue
      const { name, type, key: cfKey } = customFields.find(cf => cf.key === `cf_${key}`) || {}
      rows.push({ name: name || key, key: cfKey, value, type })
    }

    setRows(rows)
    answered(rows.length || 0)
  }

  const columns = [
    {
      dataField: 'name',
      text: 'Field'
    },
    {
      dataField: 'key',
      text: 'Key',
    },
    {
      dataField: 'type',
      text: 'Type',
      formatter: fallback
    },
    {
      dataField: 'value',
      text: 'Answer',
      formatter: fallback
    },
  ]

  return <DefaultTable keyField="key"
    noDataIndication={() => 'No content to show.'}
    data={rows || []}
    columns={columns}
    bordered={false}
  />
}

CustomFieldsResult.propTypes = propTypes

export default CustomFieldsResult

const internalUseCases = key => key.endsWith('_key') || key.endsWith('_trustedform') || key.endsWith('_leadid')
